import z from "zod";
import { urlRegex } from "@miplatform/constants";
import { StepType } from "@miplatform/types";

export const stepTemplateSchema = z
  .object({
    title: z.string().min(1, "Title is required"),
    stepType: z.nativeEnum(StepType),
    documentCategoryId: z.any().optional(),
    emailType: z.any().optional(),
    description: z.string().optional(),
    priorityOrder: z.coerce.number().optional(),
    isRequired: z.boolean().optional(),
    module: z.string().min(1, "Module is required"),
    duration: z.coerce.number().min(1, "Duration must be at least 1 minute"),
    builderDurations: z
      .array(
        z.object({
          builderId: z.string(),
          duration: z.coerce.number().optional(),
          isStepDisabledForBuilder: z.boolean().optional().default(false),
        })
      )
      .optional(),
    displayConfig: z
      .object({
        hasButton: z.boolean(),
        title: z.string(),
        content: z.string().regex(urlRegex, "Invalid URL").or(z.literal("")),
        buttonType: z.any().nullable(),
        buttonLabel: z.string().nullable(),
      })
      .optional(),
  })
  .refine(
    (data) => {
      // If Has Button is Checked, content(link), label, type is required
      if (data.displayConfig?.hasButton) {
        if (!data.displayConfig?.content) {
          return false;
        }
        if (!data.displayConfig?.buttonType) {
          return false;
        }
        if (
          data.displayConfig?.buttonType === "Link" &&
          !data.displayConfig?.buttonLabel
        ) {
          return false;
        }
      }
      return true;
    },
    {
      message:
        "Content, Button Type, and Button Label are required when Has Button is checked",
      path: ["displayConfig"],
    }
  )
  .refine(
    (data) => {
      // If stepType is Document, documentCategoryId is required
      if (data.stepType === StepType.Document && !data.documentCategoryId) {
        return false;
      }
      return true;
    },
    {
      message: "Document Category is required when Step Type is Document",
      path: ["documentCategoryId"],
    }
  )
  .refine(
    (data) => {
      // If stepType is Email, emailType is required
      if (data.stepType === StepType.Email && !data.emailType) {
        return false;
      }
      return true;
    },
    {
      message: "Email Template Type is required when Step Type is Email",
      path: ["emailType"],
    }
  )
  .refine(
    (data) => {
      if (!data.builderDurations?.length) {
        return true;
      }

      return data.builderDurations.every((bd) => {
        if (bd?.isStepDisabledForBuilder || bd?.duration == null) {
          return true;
        }

        return bd.duration > 0;
      });
    },
    {
      message: "Duration must be at least 1 minute",
      path: ["builderDurations"],
    }
  );
